import * as service from './service'

export default {
  namespace: 'widgetMallCheckCoupon',
  state: {
    queryCouponListData: []
  },
  effects: {
    * getMyShopCouponList ({ payload }, { call, put }) {
      const res = yield call(service.getMyShopCouponList, payload)
      yield put({
        type: 'save',
        payload: {
          queryCouponListData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
